var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h4", [_vm._v("Запись будет скрыта и добавлена в черный список")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "flex flex_gap_10" },
      _vm._l(_vm.btns, function (b) {
        return _c(
          "button",
          {
            staticClass: "btn btn-default",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                _vm.comment = b.title
              },
            },
          },
          [_vm._v(_vm._s(b.title))]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("textarea", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.comment,
          expression: "comment",
        },
      ],
      staticClass: "form-control mt-2",
      attrs: { placeholder: "Комментарий", rows: "2" },
      domProps: { value: _vm.comment },
      on: {
        input: function ($event) {
          if ($event.target.composing) return
          _vm.comment = $event.target.value
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }